document.addEventListener('DOMContentLoaded', () => {
  // Only target stacked variation blocks
  const stackedMenus = document.querySelectorAll('.wp-block-modulr-vertical-menu[data-variation="stacked"]');
  
  // Helper function to deactivate a menu item and all its nested children
  const deactivateMenuItem = (menuItem) => {
    if (!menuItem) return;
    
    menuItem.classList.remove('sub-active');
    menuItem.setAttribute('aria-expanded', 'false');
    
    // Find and reset styles on the direct child submenu only
    const submenu = menuItem.querySelector(':scope > .children, :scope > .sub-menu, :scope > ul');
    if (submenu) {
      submenu.style.setProperty('left', '110%', 'important'); // Use !important to override CSS !important when deactivating
      submenu.style.top = '';
      submenu.style.width = '';
      submenu.style.height = '';
      submenu.style.display = '';
      submenu.style.flexDirection = '';
      submenu.style.zIndex = '100'; // Explicitly set to base z-index
    }
    
    // Recursively deactivate all nested children (direct children of the submenu)
    const directSubmenu = menuItem.querySelector(':scope > .children, :scope > .sub-menu, :scope > ul');
    if (directSubmenu) {
      const nestedItems = directSubmenu.querySelectorAll(':scope > li.menu-item-has-children.sub-active, :scope > li.page_item_has_children.sub-active');
      nestedItems.forEach(nestedItem => {
        deactivateMenuItem(nestedItem);
      });
    }
  };
  
  // Get the currently visible menu layer (root ul or active submenu) for a nav
  const getVisibleLayer = (nav) => {
    const activeParent = nav.querySelector('li.sub-active');
    if (activeParent) {
      return activeParent.querySelector(':scope > .children, :scope > .sub-menu, :scope > ul');
    }
    return nav.querySelector(':scope > ul');
  };

  // Update nav and visible submenu height so the tallest visible layer is not cut off
  const updateStackedMenuHeight = (nav) => {
    const visibleLayer = getVisibleLayer(nav);
    const rootList = nav.querySelector(':scope > ul');
    if (!visibleLayer) return;
    const contentHeight = visibleLayer.scrollHeight;
    nav.style.height = contentHeight + 'px';
    if (visibleLayer !== rootList) {
      visibleLayer.style.height = contentHeight + 'px';
    }
  };

  stackedMenus.forEach(menuBlock => {
    // Inject back buttons before each submenu
    // Support both WordPress menu classes (menu-item-has-children) and page list classes (page_item_has_children)
    const submenus = menuBlock.querySelectorAll('.menu-item-has-children > .sub-menu, .page_item_has_children > .children, .page_item_has_children > ul');
    const backButtonText = menuBlock.dataset.stackedBackButtonText || 'Back';
    const showIcon = menuBlock.dataset.stackedBackButtonIcon !== 'false';
    
    submenus.forEach(submenu => {
      // Check if back button already exists (avoid duplicates)
      if (submenu.querySelector('.menu-back-button-wrapper')) {
        return;
      }
      
      const parentLi = submenu.parentElement;
      const parentLink = parentLi?.querySelector(':scope > a') || parentLi?.querySelector('a');
      const parentHref = parentLink?.getAttribute('href');
      const isRealUrl = parentHref && parentHref !== '#' && parentHref !== '#/';
      
      // Inject parent link if it's a real URL
      if (isRealUrl) {
        const parentLinkItem = document.createElement('li');
        parentLinkItem.className = 'menu-item menu-item-parent-link';
        parentLinkItem.innerHTML = parentLink.outerHTML;
        submenu.insertBefore(parentLinkItem, submenu.firstChild);
      }
      
      // Inject back button
      const backIcon = showIcon ? '<span class="back-icon">←</span>' : '';
      const backButton = document.createElement('li');
      backButton.className = 'menu-back-button-wrapper';
      backButton.innerHTML = `
        <div class="menu-back-button" role="button" tabindex="0" aria-label="${backButtonText}">
          <span class="back-text">${backButtonText}</span>
          ${backIcon}
        </div>
      `;
      submenu.insertBefore(backButton, submenu.firstChild);
    });
    
    // Set arrow alignment data attributes based on CSS custom properties
    // This allows CSS to apply left/right alignment transforms
    const setArrowAlignment = () => {
      const allParentItems = menuBlock.querySelectorAll('li.menu-item-has-children, li.page_item_has_children');
      allParentItems.forEach(li => {
        const computedStyle = window.getComputedStyle(li);
        const arrowAlignment = computedStyle.getPropertyValue('--stacked-arrow-alignment')?.trim();
        if (arrowAlignment === 'left') {
          li.setAttribute('data-arrow-alignment', 'left');
        } else {
          li.removeAttribute('data-arrow-alignment');
        }
      });
    };
    
    // Set initial nav height to match root menu so container is not cut off
    const nav = menuBlock.querySelector('nav');
    if (nav) {
      updateStackedMenuHeight(nav);
    }
    
    // Set alignment on initial load
    setArrowAlignment();
    
    // Re-set alignment when styles change (e.g., after StyleBlock updates)
    const observer = new MutationObserver(() => {
      setArrowAlignment();
    });
    observer.observe(menuBlock, { attributes: true, attributeFilter: ['style'] });
    
    // Handle menu items with children - attach to parent li (not link) because pointer-events: none on link
    // Support both WordPress menu classes (menu-item-has-children) and page list classes (page_item_has_children)
    const parentItems = menuBlock.querySelectorAll('li.menu-item-has-children, li.page_item_has_children');
    
    parentItems.forEach(parentLi => {
      const link = parentLi.querySelector(':scope > a') || parentLi.querySelector('a');
      if (!link) return;
      
      // Force pointer-events: none via JavaScript as fallback (CSS may not be compiled yet)
      link.style.pointerEvents = 'none';
      
      // Also attach handler directly to link with capture phase to catch it early and prevent mobile menu from closing
      link.addEventListener('click', (e) => {
        // Only prevent if this is a parent item with children (not a leaf node)
        if (parentLi.classList.contains('menu-item-has-children') || parentLi.classList.contains('page_item_has_children')) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
        }
      }, true); // Use capture phase to intercept before mobile menu handler
      
      // Attach click handler to parent li (not link) because pointer-events: none prevents link from receiving events
      parentLi.addEventListener('click', (e) => {
        // Don't handle if clicking back button or injected parent link
        if (e.target.closest('.menu-back-button') || e.target.closest('.menu-item-parent-link')) {
          return;
        }
        
        // Don't handle if clicking inside submenu - check if target is actually inside the submenu element
        const submenuElement = parentLi.querySelector('.sub-menu, .children, ul');
        if (submenuElement && submenuElement.contains(e.target)) {
          return;
        }
        
        // If we got here, we're clicking on the parent li or its link - activate submenu
        e.preventDefault(); // Prevent link navigation
        e.stopPropagation(); // Prevent bubbling to mobile menu close handler
        e.stopImmediatePropagation(); // Prevent other handlers on same element from running
        
        // Remove sub-active from siblings and all their nested children
        const siblings = Array.from(parentLi.parentElement.children);
        siblings.forEach(sibling => {
          if (sibling !== parentLi && (sibling.classList.contains('menu-item-has-children') || sibling.classList.contains('page_item_has_children'))) {
            deactivateMenuItem(sibling);
          }
        });
        
        parentLi.classList.add('sub-active');
        parentLi.setAttribute('aria-expanded', 'true');
        
        // Force the left position via JavaScript as fallback (CSS may not be applied yet)
        const submenu = parentLi.querySelector('.children, .sub-menu, ul');
        if (submenu) {
          const parentNav = submenu.closest('nav');
          submenu.style.setProperty('left', '0', 'important'); // Use !important to override CSS !important
          submenu.style.top = '0'; // Position relative to nav (which has position: relative)
          submenu.style.zIndex = '101'; // Ensure active submenu appears above others
          // Width is already 100vw in CSS, but ensure it's applied
          submenu.style.width = '100vw';
          // Force flex-direction as fallback if CSS isn't working
          submenu.style.display = 'flex';
          submenu.style.flexDirection = 'column';
          // Dynamic height: expand nav and submenu so taller child is not cut off
          if (parentNav) {
            updateStackedMenuHeight(parentNav);
          }
        }
      });
      
      // Keyboard support - attach to link for keyboard events (these still work with pointer-events: none)
      link.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          e.stopPropagation();
          
          // Remove sub-active from siblings and all their nested children
          const siblings = Array.from(parentLi.parentElement.children);
          siblings.forEach(sibling => {
            if (sibling !== parentLi && (sibling.classList.contains('menu-item-has-children') || sibling.classList.contains('page_item_has_children'))) {
              deactivateMenuItem(sibling);
            }
          });
          
          parentLi.classList.add('sub-active');
          parentLi.setAttribute('aria-expanded', 'true');
          
          const submenu = parentLi.querySelector('.children, .sub-menu, ul');
          const parentNav = submenu?.closest('nav');
          if (submenu && parentNav) {
            submenu.style.setProperty('left', '0', 'important');
            submenu.style.top = '0';
            submenu.style.zIndex = '101';
            submenu.style.width = '100vw';
            submenu.style.display = 'flex';
            submenu.style.flexDirection = 'column';
            updateStackedMenuHeight(parentNav);
          }
        }
      });
    });
    
    // Handle back buttons (use event delegation for dynamically added buttons)
    menuBlock.addEventListener('click', (e) => {
      const backBtn = e.target.closest('.menu-back-button');
      if (backBtn) {
        e.stopPropagation();
        e.preventDefault();
        
        // Find the submenu that contains the back button, then find its parent li
        const backButtonWrapper = backBtn.closest('.menu-back-button-wrapper');
        if (backButtonWrapper) {
          const submenu = backButtonWrapper.parentElement; // ul.sub-menu or .children
          const parentLi = submenu?.parentElement; // The li.menu-item-has-children or li.page_item_has_children
          if (parentLi && (parentLi.classList.contains('menu-item-has-children') || parentLi.classList.contains('page_item_has_children'))) {
            // Deactivate this parent and all its nested children
            deactivateMenuItem(parentLi);
            const navEl = menuBlock.querySelector('nav');
            if (navEl) updateStackedMenuHeight(navEl);
          }
        }
      }
    });
    
    // Keyboard support for back buttons (event delegation)
    menuBlock.addEventListener('keydown', (e) => {
      const backBtn = e.target.closest('.menu-back-button');
      if (backBtn && (e.key === 'Enter' || e.key === ' ')) {
        e.preventDefault();
        e.stopPropagation();
        
        // Find the submenu that contains the back button, then find its parent li
        const backButtonWrapper = backBtn.closest('.menu-back-button-wrapper');
        if (backButtonWrapper) {
          const submenu = backButtonWrapper.parentElement; // ul.sub-menu or .children
          const parentLi = submenu?.parentElement; // The li.menu-item-has-children or li.page_item_has_children
          if (parentLi && (parentLi.classList.contains('menu-item-has-children') || parentLi.classList.contains('page_item_has_children'))) {
            // Deactivate this parent and all its nested children
            deactivateMenuItem(parentLi);
            const navEl = menuBlock.querySelector('nav');
            if (navEl) updateStackedMenuHeight(navEl);
          }
        }
      }
    });
  });
});
